var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.75,
    height: 12.75,
    viewBox: "0 0 12.75 12.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M9.75,3.375A6.375,6.375,0,1,0,16.125,9.75,6.374,6.374,0,0,0,9.75,3.375Zm3.264,4.613L8.916,12.1h0a.554.554,0,0,1-.356.169A.537.537,0,0,1,8.2,12.1L6.483,10.381a.122.122,0,0,1,0-.175l.546-.546a.119.119,0,0,1,.172,0l1.361,1.361L12.3,7.255a.121.121,0,0,1,.086-.037h0a.111.111,0,0,1,.086.037l.536.555A.121.121,0,0,1,13.014,7.988Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#6cd098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.9546dced4fd43cd2544e127a883da6c5.svg";
export { ForwardRef as ReactComponent };